// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__25od3","name":"Header_name__1QdvY","birthday":"Header_birthday__366mL","skeleton":"Header_skeleton__3jhyR"};